import { render, staticRenderFns } from "./ManagerEdit.vue?vue&type=template&id=da87c97a&"
import script from "./ManagerEdit.vue?vue&type=script&lang=js&"
export * from "./ManagerEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports